import userRolesDisplayTextMapping from '../constants/userRolesDisplayTextMapping';

export default role =>
    userRolesDisplayTextMapping[role];